export default __webpack_public_path__ + "static/media/caretas.25c463d2.png";